import type { IOrganizationFeatureClientPortalSystemInvite } from './OrganizationFeatureClientPortalSystemInvite.interface';

export default class OrganizationFeatureClientPortalSystemInvite
  implements IOrganizationFeatureClientPortalSystemInvite {
  custom: boolean;
  content: string;

  static build = (data: IOrganizationFeatureClientPortalSystemInvite) =>
    new OrganizationFeatureClientPortalSystemInvite(data);
  static blank = () => new OrganizationFeatureClientPortalSystemInvite();

  /**
   * Constructor
   * @param {IOrganizationFeatureClientPortalSystemInvite} data
   */
  constructor(data?: IOrganizationFeatureClientPortalSystemInvite) {
    this.custom = data?.custom === true;
    this.content = data?.content || undefined;
  }
}
